import script from "./ServiceForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceForm.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceForm.vue?vue&type=style&index=0&id=5e7a8e07&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e7a8e07"]])

export default __exports__